import { ReactNode, createContext, useState } from 'react'


const PleasWaitContext = createContext({});

export const PleasWaitProvider = ({ children }: { children: ReactNode }) => {
    const [pleasWaitPopup, setPleasWaitPopup] = useState<boolean>(false);

    const value = { pleasWaitPopup, setPleasWaitPopup };

    return (
        <PleasWaitContext.Provider value={value}>
            {children}
        </PleasWaitContext.Provider>
    )
}

export default PleasWaitContext
